
import React from 'react';
import { MessageCircle } from 'lucide-react';
import { BUSINESS_INFO } from '../constants';

const WhatsAppButton: React.FC = () => {
  const whatsappUrl = `https://wa.me/${BUSINESS_INFO.phone.replace(/[^0-9]/g, '')}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-[90] bg-emerald-500 text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:bg-emerald-600 hover:scale-110 active:scale-95 group animate-pulse-emerald"
      aria-label="Contact us on WhatsApp"
    >
      <div className="relative">
        <MessageCircle className="h-7 w-7" />
        <span className="absolute -top-12 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-[10px] font-bold px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Chat with us
          <span className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-slate-900"></span>
        </span>
      </div>
    </a>
  );
};

export default WhatsAppButton;
